import { initializeRum } from '@tcc/analytics';

declare global {
  interface Window {
    fieldViewRumInitialized?: boolean;
  }
}

if (!window.fieldViewRumInitialized) {
  window.fieldViewRumInitialized = true;

  initializeRum({
    applicationId: '5735ee39-1865-4edc-9b79-09ed301c17aa',
    clientToken: 'pub0c9b9b4ce81b52c27cc300e0db1bff47',
    site: 'datadoghq.com',
    service: 'fieldview-new-arch',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
    allowedTracingUrls: [
      { match: 'https://local.climate.com/v2/graphql', propagatorTypes: ['datadog']},
      { match: 'https://ol.na.climate.com/v2/graphql', propagatorTypes: ['datadog']},
      { match: 'https://uapi.climate.com/app/graphql', propagatorTypes: ['tracecontext']}
    ],
    env: process.env.NODE_ENV,
    version: process.env.npmPackageVersion,
  });
}

